// Complete translations for FR, EN, DE - including ALL content

export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      skills: "Compétences",
      missions: "Missions",
      employers: "Employeurs",
      certifications: "Certifications",
      projects: "Projets IA",
      contact: "Contact",
      downloadCV: "Télécharger CV"
    },
    // Profile
    profile: {
      name: "Joel Dossa",
      title: "Consultant Senior Data & Business Intelligence",
      summary: "Consultant Data & Business Intelligence senior, j'accompagne les organisations dans la conception et le déploiement de solutions décisionnelles robustes, de la modélisation des données jusqu'à la mise à disposition d'outils d'aide à la décision à forte valeur métier. Habitué aux environnements complexes et multi-clients, j'interviens sur des projets BI exigeants, en France comme à l'international.",
      location: "France",
      availability: "Ouvert aux opportunités"
    },
    // Highlights
    highlights: [
      "9+ ans d'expérience en Data & BI",
      "Expert en systèmes décisionnels",
      "Spécialiste modélisation de données",
      "Expérience multi-clients & internationale"
    ],
    // Home page
    home: {
      label: "Consultant Senior",
      title1: "Data &",
      title2: "Business",
      title3: "Intelligence",
      yearsExp: "Années d'expérience",
      projectsDelivered: "Projets livrés",
      sectorsCovered: "Secteurs couverts",
      countries: "Pays",
      skillsCard: {
        title: "Compétences & Expertise",
        description: "Compétences techniques, outils BI et savoir-faire",
        cta: "Explorer"
      },
      missionsCard: {
        title: "Portfolio Missions",
        description: "Missions de conseil dans divers secteurs",
        cta: "Voir les missions"
      },
      employersCard: {
        title: "Parcours Professionnel",
        description: "Employeurs et cabinets de conseil",
        cta: "Voir les employeurs"
      }
    },
    // Skills page
    skills: {
      label: "Ce que je fais",
      title: "Compétences & Expertise",
      description: "Cliquez sur une compétence pour explorer les missions, clients et employeurs associés.",
      missions: "missions",
      relatedMissions: "Missions associées",
      employers: "Employeurs",
      categories: {
        core: "Compétences clés",
        tools: "Outils BI",
        technical: "Compétences techniques",
        business: "Compétences métier",
        management: "Management"
      }
    },
    // Skills data
    skillsData: [
      { id: "bi", name: "Business Intelligence", category: "Core", description: "Conception, implémentation et gouvernance de solutions BI de bout en bout", missionCount: 6 },
      { id: "qlik", name: "Qlik Sense / QlikView", category: "Tools", description: "Développement de tableaux de bord, modélisation de données, analyse d'ensembles, NPrinting", missionCount: 4 },
      { id: "powerbi", name: "Power BI", category: "Tools", description: "Développement de rapports, DAX, Power Query, dataflows", missionCount: 2 },
      { id: "datamodel", name: "Modélisation & Entrepôt de données", category: "Core", description: "Schéma en étoile, modélisation dimensionnelle, data vault", missionCount: 5 },
      { id: "sql", name: "SQL & Bases de données", category: "Technical", description: "SQL Server, Oracle, PostgreSQL, optimisation des requêtes", missionCount: 5 },
      { id: "etl", name: "ETL & Intégration de données", category: "Technical", description: "Talend, SSIS, pipelines de données, intégration API", missionCount: 3 },
      { id: "kpi", name: "KPI & Aide à la décision", category: "Business", description: "Définition de KPI, tableaux de bord de pilotage, reporting exécutif", missionCount: 5 },
      { id: "dataquality", name: "Qualité & Gouvernance des données", category: "Business", description: "Cadres de qualité des données, gestion des données de référence, documentation", missionCount: 3 },
      { id: "project", name: "Gestion de projet & Parties prenantes", category: "Management", description: "Agile/Scrum, coordination des parties prenantes, recueil des besoins", missionCount: 6 },
      { id: "training", name: "Formation & Accompagnement utilisateurs", category: "Management", description: "Conception de supports pédagogiques, animation de formations BI, accompagnement des utilisateurs et montée en compétence des équipes", missionCount: 3 }
    ],
    // Employers data
    employersData: [
      { id: "keyrus", name: "Keyrus", type: "Cabinet de conseil", duration: "Janvier 2025 - Présent", location: "Paris, France", description: "Groupe international de conseil en intelligence des données" },
      { id: "itcoop", name: "IT-COOP", type: "Cabinet de conseil", duration: "Janvier 2023 - Décembre 2024", location: "Paris, France", description: "Cabinet de conseil spécialisé en Data & Business Intelligence" },
      { id: "vo2", name: "VO2 GROUP", type: "Cabinet de conseil", duration: "Septembre 2017 - Décembre 2022", location: "Paris, France", description: "Cabinet de conseil Data & Digital" },
      { id: "gmf", name: "GMF Groupe Covéa", type: "Client final", duration: "Décembre 2016 - Août 2017", location: "Paris, France", description: "Grand groupe d'assurance français au sein de Covéa" }
    ],
    // Missions data
    missionsData: [
      { id: "m6", title: "Formateur & Responsable supports Qlik Sense", employer: "keyrus", client: "CMA CGM", sector: "Transport / Maritime / Logistique", country: "France", context: "Développement d'une application Qlik Sense dédiée au suivi des accords de partenariats maritimes, dans le cadre de la stratégie d'optimisation du département Pool & Partnership. L'objectif est de fournir aux équipes métier un outil de reporting et d'analyse pour le pilotage des allocations d'espace sur les navires et l'évaluation de la performance des partenariats.", techs: "Qlik Sense, JSON, Excel, SharePoint, VS Code, GitLab" },
      { id: "m7", title: "Référent BI", employer: "itcoop", client: "IT-COOP (mission interne)", sector: "Conseil / Business Intelligence", country: "France", context: "Mise en place et gestion de la plateforme Qlik Sense interne. Encadrement des nouveaux arrivants, formation, support et veille technologique afin d'assurer l'optimisation continue et l'adaptation des solutions BI aux besoins métiers. Point de contact principal pour toute question technique ou fonctionnelle relative à Qlik Sense au sein de l'entreprise.", techs: "Qlik Sense, Power BI" },
      { id: "m8", title: "Développeur Qlik Sense", employer: "itcoop", client: "Bpifrance", sector: "Banque / Finance publique", country: "France", context: "Conception, maintenance évolutive et corrective d'applications Qlik Sense. Optimisation des modèles de données afin de réduire les temps de chargement et améliorer les performances applicatives. Applications concernées : GED (Gestion Électronique des Documents), MaReco (Outil de marketing digital), Matomo (Mesure d'audience), ACE (Accompagnement des Entreprises), UNIV (Suivi des données de formation).", techs: "Qlik Sense, GitLab, Jenkins, AWS, Jira, Neurone, Datalink (DataGalaxy)" },
      { id: "m9", title: "Optimisation des ventes et de la performance retail via Power BI et SQL Server", employer: "itcoop", client: "Super U Bénin", sector: "Retail / Grande distribution", country: "Bénin", context: "Projet d'analyse et de pilotage des ventes visant à réduire les ruptures de stock, améliorer la rotation des produits et fournir des indicateurs clés aux métiers du retail. Structuration des flux de données entre les systèmes sources (ERP, e-commerce, commandes clients) et modélisation d'un entrepôt de données performant pour alimenter des dashboards Power BI.", techs: "SQL Server, SSIS, Power BI, DAX, Power Query, MongoDB, Python, Azure ML, Data Quality Services (DQS), Excel" },
      { id: "m10", title: "Développeur BI", employer: "gmf", client: "GMF Groupe Covéa", sector: "Assurance / Services financiers", country: "France", context: "Mission d'analyse et de suivi de l'activité du centre de contact de la GMF VIE, visant à fournir une vision consolidée et fiable de la performance opérationnelle et des flux de téléphonie afin de soutenir la prise de décision.", techs: "Oracle SQL Developer, IBM DB2, SAS Add-In, Excel, Business Objects, Power BI" },
      { id: "m11", title: "Formateur et Responsable Supports Qlik Sense", employer: "vo2", client: "VO2 GROUP / Orsys", sector: "Conseil / Formation BI", country: "France", context: "Mission de formation et de support autour de Qlik Sense, réalisée en interne chez VO2 GROUP et auprès d'entreprises clientes dans le cadre de partenariats avec Orsys.", techs: "QlikView, Qlik Sense" },
      { id: "m12", title: "Développeur Qlik Sense", employer: "vo2", client: "BNP Paribas CIB", sector: "Banque d'investissement", country: "France", context: "Développement de tableaux de bord budgétaires liés à la consommation de matériel informatique.", techs: "Qlik Sense, NPrinting, Oracle, Excel" },
      { id: "m13", title: "Pilotage de la performance financière et des risques réglementaires", employer: "vo2", client: "Banque Atlantique", sector: "Banque", country: "Bénin", context: "Mise en place d'un outil centralisé de suivi de la performance financière, des indicateurs de risque et de la conformité réglementaire, aligné avec les normes de la BCEAO.", techs: "SQL Server, Microsoft Fabric, SSIS, Python, Power BI, DAX, Excel, Git" },
      { id: "m14", title: "Analyse RH et engagement des employés", employer: "vo2", client: "Institut Universitaire La Grâce", sector: "Éducation / RH", country: "Bénin", context: "Mise en place d'un outil analytique RH pour le suivi de la performance RH, de l'absentéisme et de l'engagement des employés.", techs: "SQL Server, Microsoft Fabric, SSIS, MongoDB, Python (NLP), Power BI, DAX, Excel" },
      { id: "m15", title: "Chef de projet / Développeur Qlik Sense", employer: "vo2", client: "Alstom", sector: "Industrie / Transport", country: "France", context: "Maintenance évolutive d'applications Qlik Sense dans le cadre de l'évaluation et de l'optimisation des coûts de production des trains.", techs: "Oracle, Qlik Sense" },
      { id: "m16", title: "Expertise Qlik Sense", employer: "vo2", client: "Saint-Gobain", sector: "Industrie", country: "France", context: "Optimisation stratégique du modèle de données et accompagnement à la conception de la version 2 de l'application DecQlik dédiée au suivi des ventes.", techs: "Qlik Sense, SQL Server, Jira" },
      { id: "m17", title: "Développeur Qlik Sense", employer: "vo2", client: "LVMH-PCIS", sector: "Luxe", country: "International (Europe, Asie, Chine)", context: "Projet CLIENTQUEST visant le support et le développement d'applications Qlik Sense sur plusieurs plateformes internationales.", techs: "Qlik Sense, Azure, SQL Server, Jira" },
      { id: "m18", title: "Expertise Qlik Sense", employer: "vo2", client: "Carrefour", sector: "Retail / E-commerce", country: "France", context: "Projet de transformation digitale de l'activité e-commerce.", techs: "Qlik Sense, PostgreSQL" },
      { id: "m19", title: "Développeur QlikView", employer: "vo2", client: "Lafarge", sector: "Industrie / Supply Chain", country: "France", context: "Projet EBM visant à optimiser la performance de la Supply Chain et la prise de décision opérationnelle.", techs: "QlikView" },
      { id: "m20", title: "Data Analyst – Audit interne", employer: "vo2", client: "Nonvi Voyage", sector: "Tourisme / Audit", country: "Bénin", context: "Accompagnement des équipes d'audit interne dans la récupération, l'exploitation et l'analyse des données.", techs: "Python, Excel, Power BI" }
    ],
    // Mission details (responsibilities)
    missionDetails: {
      m6: [
        "Recueil et formalisation des besoins fonctionnels auprès des équipes métiers (contrôleurs de gestion partenariats, analystes Pool & Partnership, équipe BI interne)",
        "Modélisation des données issues de différentes sources internes",
        "Développement de tableaux de bord Qlik Sense dynamiques et interactifs",
        "Mise en place de KPI métiers pour le suivi des performances des accords",
        "Rédaction de la documentation technique et fonctionnelle de l'application",
        "Accompagnement des utilisateurs lors de la phase de prise en main"
      ],
      m7: [
        "Mise en place et gestion de la plateforme Qlik Sense",
        "Encadrement des nouveaux arrivants sur Qlik Sense",
        "Formation et accompagnement des collaborateurs",
        "Création de supports de formation et animation de sessions internes",
        "Support fonctionnel et technique aux utilisateurs",
        "Veille technologique sur l'écosystème Qlik et Power BI"
      ],
      m8: [
        "Cadrage des besoins métiers et planification des tâches",
        "Création et gestion des QVDs (QVD Maker)",
        "Conception et maintenance évolutive des applications Qlik Sense",
        "Optimisation des temps de chargement",
        "Revues fonctionnelles avec les métiers",
        "Déploiement et suivi en production",
        "Documentation fonctionnelle et technique (Neurone, Datalink / DataGalaxy)"
      ],
      m9: [
        "Conception et automatisation des flux de données via SSIS",
        "Intégration des données e-commerce issues de MongoDB via scripts Python",
        "Modélisation du Data Warehouse (dimensions lentes, historisation des stocks et prix)",
        "Création de dashboards Power BI (ventes, ruptures, rotation)",
        "Définition des KPIs métiers et accompagnement des utilisateurs",
        "Mise en place de règles de qualité et de gouvernance des données (DQS, Power Query)"
      ],
      m10: [
        "Collecte et analyse détaillée des données d'activité du centre de contact de la GMF VIE afin d'améliorer la compréhension des processus de gestion de la téléphonie",
        "Développement de tableaux de bord graphiques à partir des données issues des outils de gestion du centre de contact, offrant une vision globale et synthétique de l'activité",
        "Réalisation de tests sous Business Objects pour valider la fiabilité des statistiques de téléphonie",
        "Extraction de statistiques spécifiques à l'aide de requêtes SQL pour répondre à des besoins ponctuels d'analyse",
        "Élaboration de prévisions sur l'évolution de l'activité du centre de contact afin d'orienter les décisions stratégiques et opérationnelles"
      ],
      m11: [
        "Élaboration de supports pédagogiques (guides, tutoriels) pour faciliter l'apprentissage de Qlik Sense",
        "Animation de sessions de formation pour les équipes internes",
        "Intervention en tant que formateur pour des entreprises clientes d'Orsys",
        "Adaptation des contenus et méthodes pédagogiques selon les besoins des utilisateurs",
        "Suivi et assistance post-formation",
        "Veille pédagogique et technique sur les évolutions de Qlik Sense"
      ],
      m12: [
        "Maintenance et évolution des applications Qlik Sense",
        "Mise à jour et fiabilisation des sources de données",
        "Refonte des applications pour améliorer l'expérience utilisateur",
        "Optimisation des temps de chargement et des performances"
      ],
      m13: [
        "Intégration des transactions financières dans SQL Server via scripts Python",
        "Centralisation des données comptables et réglementaires via Microsoft Fabric",
        "Ingestion automatisée des historiques comptables via SSIS",
        "Calcul d'indicateurs de risque (VaR, Sharpe ratio, drawdown)",
        "Création de mesures financières complexes en DAX",
        "Développement de dashboards Power BI pour la direction et les analystes",
        "Mise en place de règles de conformité et d'alertes réglementaires"
      ],
      m14: [
        "Intégration des données RH via SSIS et Microsoft Fabric",
        "Structuration des enquêtes internes dans MongoDB",
        "Analyse NLP des commentaires employés via Python",
        "Création de KPIs RH en DAX",
        "Développement de dashboards Power BI",
        "Mise en place d'un modèle prédictif simple de churn RH"
      ],
      m15: [
        "Cadrage et recueil des besoins métiers",
        "Conception de modèles de données et tableaux de bord de simulation des coûts",
        "Suivi budgétaire des projets",
        "Formation et accompagnement des utilisateurs",
        "Gestion des incidents et documentation"
      ],
      m16: [
        "Analyse et structuration des besoins métier",
        "Optimisation du modèle de données existant",
        "Définition des bonnes pratiques de développement Qlik Sense",
        "Cadrage technique et fonctionnel de la nouvelle version"
      ],
      m17: [
        "Maintenance évolutive et corrective des applications Qlik Sense",
        "Support applicatif multi-zones",
        "Déploiement de nouvelles fonctionnalités",
        "Développement d'applications métiers",
        "Tests de non-régression"
      ],
      m18: [
        "Installation et configuration du serveur Qlik Sense",
        "Recueil des besoins des différentes entités",
        "Développement des transformations de données",
        "Production de rapports et analyses orientés business",
        "Application des pratiques Agile"
      ],
      m19: [
        "Mapping des données Supply Chain",
        "Développement de rapports QlikView",
        "Analyse des flux de transport et des coûts associés",
        "Suivi des performances fournisseurs",
        "Coordination avec la Supply Chain et la DSI"
      ],
      m20: [
        "Collecte, nettoyage et fiabilisation des données",
        "Analyse exploratoire et data mining",
        "Visualisation des données pour le support aux audits",
        "Documentation technique et métier des analyses"
      ]
    },
    // Missions page
    missions: {
      label: "Travaux sélectionnés",
      title: "Portfolio Missions",
      description: "Une sélection de missions de conseil dans différents secteurs et technologies.",
      filterLabel: "Filtrer les missions",
      clearAll: "Tout effacer",
      allTechnologies: "Toutes les technologies",
      allSectors: "Tous les secteurs",
      allCountries: "Tous les pays",
      allEmployers: "Tous les employeurs",
      allSkills: "Toutes les compétences",
      filteredBySkill: "Filtré par compétence",
      internalMission: "mission interne",
      showing: "Affichage de",
      of: "sur",
      missionsLabel: "missions",
      noResults: "Aucune mission ne correspond à vos filtres.",
      clearFilters: "Effacer les filtres",
      businessContext: "Contexte métier",
      responsibilities: "Principales responsabilités",
      technologies: "Technologies utilisées"
    },
    // Employers page
    employers: {
      label: "Parcours professionnel",
      title: "Employeurs",
      description: "Les principaux employeurs et cabinets de conseil avec lesquels j'ai collaboré.",
      skillsApplied: "Compétences appliquées",
      missionsDelivered: "Missions réalisées",
      clientsServed: "Clients servis"
    },
    // Contact page
    contact: {
      label: "Me contacter",
      title: "Contact",
      description: "Je suis ouvert à discuter de nouvelles opportunités en conseil Data & Business Intelligence.",
      aboutMe: "À propos",
      aboutText: "Fort de plus de 9 ans d'expérience dans les systèmes d'aide à la décision, la modélisation de données et la livraison de solutions BI, j'ai construit mon parcours autour de contextes multi-clients, internationaux et exigeants.\n\nJ'interviens aussi bien en cadrage métier qu'en conception technique, avec une approche pragmatique orientée usages, performance et fiabilité de la donnée.\n\nQue ce soit pour renforcer une équipe sur un projet BI complexe, structurer une plateforme décisionnelle ou accompagner les utilisateurs dans la prise en main des outils, j'apporte une expertise opérationnelle et un regard de consultant senior.\n\nPour un besoin ponctuel ou une collaboration à plus long terme, je suis ouvert à l'échange.",
      openToOpportunities: "Ouvert aux opportunités",
      contactInfo: "Coordonnées",
      email: "Email",
      phone: "Téléphone",
      linkedin: "LinkedIn",
      viewProfile: "Voir le profil",
      location: "Localisation",
      locationMobility: "Localisation & Mobilité",
      mobility: "Mobilité",
      sendEmail: "Envoyer un email"
    },
    // Certifications page
    certifications: {
      title: "Certifications",
      description: "Certifications professionnelles obtenues et en cours de préparation.",
      obtained: "Certifications obtenues",
      inProgress: "Certifications en cours",
      certified: "Certifié",
      inProgressStatus: "En cours",
      issuer: "Émetteur",
      obtainedDate: "Date d'obtention",
      expirationDate: "Date d'expiration"
    },
    // Certifications data
    certificationsData: {
      obtained: [
        {
          name: "Qlik Sense Data Architect Certification",
          issuer: "Qlik",
          obtainedDate: "07 février 2025",
          expirationDate: "07 février 2027",
          badgeImage: "/images/qlik-data-architect-badge.png"
        }
      ],
      inProgress: [
        {
          name: "Microsoft Power BI PL-300",
          issuer: "Microsoft"
        }
      ]
    },
    // Contact data
    contactData: {
      email: "dossa.jojo@gmail.com",
      phone: "+33 7 84 94 73 20",
      location: "France",
      mobility: "France"
    },
    // Footer
    footer: {
      navigation: "Navigation",
      contact: "Contact",
      rights: "Tous droits réservés",
      consultant: "Consultant Data & BI"
    },
    // Common
    common: {
      endClient: "Client final",
      consultingFirm: "Cabinet de conseil"
    },
    // AI Projects page
    aiProjects: {
      label: "Projets personnels",
      title: "Projets personnels – IA & Automatisation",
      description: "Cette section présente des projets personnels dans lesquels l'IA et les outils no-code ont été utilisés pour accélérer la conception, structurer un besoin ou mettre en place une solution concrète. L'objectif n'est pas de mettre en avant l'outil en lui-même, mais le problème résolu et la manière dont la solution a été construite.",
      context: "Contexte",
      approach: "Approche",
      aiRole: "Rôle de l'IA / du no-code",
      result: "Résultat"
    },
    // AI Projects data
    aiProjectsData: [
      {
        id: "pastry-orders",
        title: "Outil de gestion de commandes pour activité de pâtisserie",
        context: "Activité artisanale avec des commandes provenant de plusieurs canaux (WhatsApp, appels, messages), entraînant des oublis, erreurs de suivi et charge mentale importante.",
        approach: "Analyse des différentes étapes de gestion des commandes (prise de commande, préparation, livraison), puis structuration d'un système simple pour centraliser les demandes et suivre les commandes.",
        aiRole: "Utilisation d'outils no-code et d'IA pour concevoir rapidement une solution adaptée à l'usage réel, tester plusieurs approches et ajuster progressivement le fonctionnement.",
        result: "Meilleure visibilité sur les commandes, réduction des oublis et gestion quotidienne plus fluide."
      },
      {
        id: "malivraison-plus",
        title: "MaLivraison+",
        context: "Conception d'une application de livraison impliquant plusieurs types d'utilisateurs (clients, livreurs, partenaires), avec des flux métier différents à structurer.",
        approach: "Travail sur l'organisation des flux principaux, la logique des interactions entre acteurs, la circulation des données et la cohérence globale du système.",
        aiRole: "Utilisation de l'IA et d'outils comme Emergent.sh pour prototyper, accélérer la conception, formaliser certaines logiques d'usage et tester rapidement différentes structures fonctionnelles.",
        result: "Passage d'une logique fragmentée à une structure plus cohérente et exploitable."
      },
      {
        id: "ai-experiments",
        title: "Expérimentations IA / no-code",
        context: "Exploration de solutions permettant de gagner du temps sur la structuration de besoins, le prototypage et l'automatisation de tâches simples.",
        approach: "Tests de différentes approches sur des cas concrets liés à la donnée, aux flux utilisateurs et à la documentation fonctionnelle.",
        aiRole: "Utilisation d'outils tels que ChatGPT, Claude, Emergent.sh, Bubble et autres solutions no-code pour expérimenter rapidement, comparer des options et produire des premières versions exploitables.",
        result: "Développement d'une approche plus rapide et plus pragmatique pour passer d'un besoin à une solution testable."
      }
    ],
    // Sectors
    sectors: ["Transport / Maritime / Logistique", "Conseil / Business Intelligence", "Banque / Finance publique", "Retail / Grande distribution", "Assurance / Services financiers", "Conseil / Formation BI", "Banque d'investissement", "Banque", "Éducation / RH", "Industrie / Transport", "Industrie", "Luxe", "Retail / E-commerce", "Industrie / Supply Chain", "Tourisme / Audit"],
    // Countries
    countries: ["France", "Bénin", "International (Europe, Asie, Chine)"]
  },

  en: {
    nav: {
      home: "Home",
      skills: "Skills",
      missions: "Missions",
      employers: "Employers",
      certifications: "Certifications",
      projects: "AI Projects",
      contact: "Contact",
      downloadCV: "Download CV"
    },
    profile: {
      name: "Joel Dossa",
      title: "Senior Data & Business Intelligence Consultant",
      summary: "As a Senior Data & Business Intelligence Consultant, I support organizations in designing and deploying robust decision-support solutions, from data modeling to delivering high-value business intelligence tools. Experienced in complex, multi-client environments, I work on demanding BI projects both in France and internationally.",
      location: "France",
      availability: "Open to opportunities"
    },
    highlights: [
      "9+ years of experience in Data & BI",
      "Expert in decision-support systems",
      "Data modeling & warehousing specialist",
      "Multi-client & international experience"
    ],
    home: {
      label: "Senior Consultant",
      title1: "Data &",
      title2: "Business",
      title3: "Intelligence",
      yearsExp: "Years Experience",
      projectsDelivered: "Projects Delivered",
      sectorsCovered: "Sectors Covered",
      countries: "Countries",
      skillsCard: {
        title: "Skills & Expertise",
        description: "Technical skills, BI tools, and competencies",
        cta: "Explore"
      },
      missionsCard: {
        title: "Mission Portfolio",
        description: "Consulting missions across industries",
        cta: "View missions"
      },
      employersCard: {
        title: "Career Path",
        description: "Employers and consulting firms",
        cta: "View employers"
      }
    },
    skills: {
      label: "What I Do",
      title: "Skills & Expertise",
      description: "Click on any skill to explore related missions, clients, and employers.",
      missions: "missions",
      relatedMissions: "Related Missions",
      employers: "Employers",
      categories: {
        core: "Core Competencies",
        tools: "BI Tools",
        technical: "Technical Skills",
        business: "Business Skills",
        management: "Management"
      }
    },
    skillsData: [
      { id: "bi", name: "Business Intelligence", category: "Core", description: "End-to-end BI solution design, implementation, and governance", missionCount: 6 },
      { id: "qlik", name: "Qlik Sense / QlikView", category: "Tools", description: "Dashboard development, data modeling, set analysis, NPrinting", missionCount: 4 },
      { id: "powerbi", name: "Power BI", category: "Tools", description: "Report development, DAX, Power Query, dataflows", missionCount: 2 },
      { id: "datamodel", name: "Data Modeling & Warehousing", category: "Core", description: "Star schema, dimensional modeling, data vault", missionCount: 5 },
      { id: "sql", name: "SQL & Databases", category: "Technical", description: "SQL Server, Oracle, PostgreSQL, query optimization", missionCount: 5 },
      { id: "etl", name: "ETL & Data Integration", category: "Technical", description: "Talend, SSIS, data pipelines, API integration", missionCount: 3 },
      { id: "kpi", name: "KPI & Decision Support", category: "Business", description: "KPI definition, steering dashboards, executive reporting", missionCount: 5 },
      { id: "dataquality", name: "Data Quality & Governance", category: "Business", description: "Data quality frameworks, master data management, documentation", missionCount: 3 },
      { id: "project", name: "Project & Stakeholder Management", category: "Management", description: "Agile/Scrum, stakeholder coordination, requirements gathering", missionCount: 6 },
      { id: "training", name: "Training & User Support", category: "Management", description: "Training materials design, BI training facilitation, user support and team skill development", missionCount: 3 }
    ],
    employersData: [
      { id: "keyrus", name: "Keyrus", type: "Consulting Firm", duration: "January 2025 - Present", location: "Paris, France", description: "International data intelligence consulting group" },
      { id: "itcoop", name: "IT-COOP", type: "Consulting Firm", duration: "January 2023 - December 2024", location: "Paris, France", description: "Consulting firm specialized in Data & Business Intelligence" },
      { id: "vo2", name: "VO2 GROUP", type: "Consulting Firm", duration: "September 2017 - December 2022", location: "Paris, France", description: "Data & Digital consulting firm" },
      { id: "gmf", name: "GMF Groupe Covéa", type: "End Client", duration: "December 2016 - August 2017", location: "Paris, France", description: "Major French insurance group within Covéa" }
    ],
    missionsData: [
      { id: "m6", title: "Qlik Sense Trainer & Support Lead", employer: "keyrus", client: "CMA CGM", sector: "Transport / Maritime / Logistics", country: "France", context: "Development of a Qlik Sense application dedicated to tracking maritime partnership agreements, as part of the Pool & Partnership department's optimization strategy. The objective is to provide business teams with a reporting and analysis tool for managing vessel space allocations and evaluating partnership performance.", techs: "Qlik Sense, JSON, Excel, SharePoint, VS Code, GitLab" },
      { id: "m7", title: "BI Lead", employer: "itcoop", client: "IT-COOP (internal mission)", sector: "Consulting / Business Intelligence", country: "France", context: "Implementation and management of the internal Qlik Sense platform. Onboarding of new employees, training, support and technology watch to ensure continuous optimization and adaptation of BI solutions to business needs. Main point of contact for any technical or functional questions related to Qlik Sense within the company.", techs: "Qlik Sense, Power BI" },
      { id: "m8", title: "Qlik Sense Developer", employer: "itcoop", client: "Bpifrance", sector: "Banking / Public Finance", country: "France", context: "Design, evolutive and corrective maintenance of Qlik Sense applications. Optimization of data models to reduce loading times and improve application performance. Applications involved: GED (Electronic Document Management), MaReco (Digital marketing tool), Matomo (Web analytics), ACE (Business Support), UNIV (Training data tracking).", techs: "Qlik Sense, GitLab, Jenkins, AWS, Jira, Neurone, Datalink (DataGalaxy)" },
      { id: "m9", title: "Sales and Retail Performance Optimization via Power BI and SQL Server", employer: "itcoop", client: "Super U Benin", sector: "Retail / Large-scale distribution", country: "Benin", context: "Sales analysis and management project aimed at reducing stockouts, improving product turnover and providing key indicators to retail business teams. Structuring data flows between source systems (ERP, e-commerce, customer orders) and modeling a high-performance data warehouse to feed Power BI dashboards.", techs: "SQL Server, SSIS, Power BI, DAX, Power Query, MongoDB, Python, Azure ML, Data Quality Services (DQS), Excel" },
      { id: "m10", title: "BI Developer", employer: "gmf", client: "GMF Groupe Covéa", sector: "Insurance / Financial Services", country: "France", context: "Analysis and monitoring mission of the GMF VIE contact center activity, aimed at providing a consolidated and reliable view of operational performance and telephony flows to support decision-making.", techs: "Oracle SQL Developer, IBM DB2, SAS Add-In, Excel, Business Objects, Power BI" },
      { id: "m11", title: "Qlik Sense Trainer & Support Lead", employer: "vo2", client: "VO2 GROUP / Orsys", sector: "Consulting / BI Training", country: "France", context: "Training and support mission around Qlik Sense, conducted internally at VO2 GROUP and with client companies through partnerships with Orsys.", techs: "QlikView, Qlik Sense" },
      { id: "m12", title: "Qlik Sense Developer", employer: "vo2", client: "BNP Paribas CIB", sector: "Investment Banking", country: "France", context: "Development of budget dashboards related to IT equipment consumption.", techs: "Qlik Sense, NPrinting, Oracle, Excel" },
      { id: "m13", title: "Financial Performance & Regulatory Risk Management", employer: "vo2", client: "Banque Atlantique", sector: "Banking", country: "Benin", context: "Implementation of a centralized tool for monitoring financial performance, risk indicators and regulatory compliance, aligned with BCEAO standards.", techs: "SQL Server, Microsoft Fabric, SSIS, Python, Power BI, DAX, Excel, Git" },
      { id: "m14", title: "HR Analytics & Employee Engagement", employer: "vo2", client: "Institut Universitaire La Grâce", sector: "Education / HR", country: "Benin", context: "Implementation of an HR analytics tool for monitoring HR performance, absenteeism and employee engagement.", techs: "SQL Server, Microsoft Fabric, SSIS, MongoDB, Python (NLP), Power BI, DAX, Excel" },
      { id: "m15", title: "Project Manager / Qlik Sense Developer", employer: "vo2", client: "Alstom", sector: "Industry / Transport", country: "France", context: "Evolutive maintenance of Qlik Sense applications for train production cost evaluation and optimization.", techs: "Oracle, Qlik Sense" },
      { id: "m16", title: "Qlik Sense Expertise", employer: "vo2", client: "Saint-Gobain", sector: "Industry", country: "France", context: "Strategic optimization of the data model and support for designing version 2 of the DecQlik application dedicated to sales tracking.", techs: "Qlik Sense, SQL Server, Jira" },
      { id: "m17", title: "Qlik Sense Developer", employer: "vo2", client: "LVMH-PCIS", sector: "Luxury", country: "International (Europe, Asia, China)", context: "CLIENTQUEST project for support and development of Qlik Sense applications across multiple international platforms.", techs: "Qlik Sense, Azure, SQL Server, Jira" },
      { id: "m18", title: "Qlik Sense Expertise", employer: "vo2", client: "Carrefour", sector: "Retail / E-commerce", country: "France", context: "Digital transformation project for e-commerce activity.", techs: "Qlik Sense, PostgreSQL" },
      { id: "m19", title: "QlikView Developer", employer: "vo2", client: "Lafarge", sector: "Industry / Supply Chain", country: "France", context: "EBM project to optimize Supply Chain performance and operational decision-making.", techs: "QlikView" },
      { id: "m20", title: "Data Analyst – Internal Audit", employer: "vo2", client: "Nonvi Voyage", sector: "Tourism / Audit", country: "Benin", context: "Support for internal audit teams in data collection, exploitation and analysis.", techs: "Python, Excel, Power BI" }
    ],
    missionDetails: {
      m6: [
        "Gathering and formalizing functional requirements from business teams (partnership controllers, Pool & Partnership analysts, internal BI team)",
        "Data modeling from various internal sources",
        "Development of dynamic and interactive Qlik Sense dashboards",
        "Implementation of business KPIs for tracking agreement performance",
        "Writing technical and functional documentation for the application",
        "User support during the onboarding phase"
      ],
      m7: [
        "Implementation and management of the Qlik Sense platform",
        "Onboarding of new employees on Qlik Sense",
        "Training and support for team members",
        "Creation of training materials and facilitation of internal sessions",
        "Functional and technical support for users",
        "Technology watch on Qlik and Power BI ecosystem"
      ],
      m8: [
        "Business requirements gathering and task planning",
        "Creation and management of QVDs (QVD Maker)",
        "Design and evolutive maintenance of Qlik Sense applications",
        "Loading time optimization",
        "Functional reviews with business teams",
        "Production deployment and monitoring",
        "Functional and technical documentation (Neurone, Datalink / DataGalaxy)"
      ],
      m9: [
        "Design and automation of data flows via SSIS",
        "Integration of e-commerce data from MongoDB via Python scripts",
        "Data Warehouse modeling (slowly changing dimensions, stock and price historization)",
        "Creation of Power BI dashboards (sales, stockouts, turnover)",
        "Definition of business KPIs and user support",
        "Implementation of data quality and governance rules (DQS, Power Query)"
      ],
      m10: [
        "Collection and detailed analysis of GMF VIE contact center activity data to improve understanding of telephony management processes",
        "Development of graphical dashboards from contact center management tools data, providing a comprehensive and synthetic view of activity",
        "Testing under Business Objects to validate the reliability of telephony statistics",
        "Extraction of specific statistics using SQL queries to meet ad-hoc analysis needs",
        "Development of forecasts on contact center activity evolution to guide strategic and operational decisions"
      ],
      m11: [
        "Development of training materials (guides, tutorials) to facilitate Qlik Sense learning",
        "Facilitation of training sessions for internal teams",
        "Trainer interventions for Orsys client companies",
        "Adaptation of content and teaching methods according to user needs",
        "Post-training follow-up and assistance",
        "Educational and technical watch on Qlik Sense evolutions"
      ],
      m12: [
        "Maintenance and evolution of Qlik Sense applications",
        "Update and reliability of data sources",
        "Application redesign to improve user experience",
        "Loading time and performance optimization"
      ],
      m13: [
        "Integration of financial transactions into SQL Server via Python scripts",
        "Centralization of accounting and regulatory data via Microsoft Fabric",
        "Automated ingestion of accounting histories via SSIS",
        "Calculation of risk indicators (VaR, Sharpe ratio, drawdown)",
        "Creation of complex financial measures in DAX",
        "Development of Power BI dashboards for management and analysts",
        "Implementation of compliance rules and regulatory alerts"
      ],
      m14: [
        "Integration of HR data via SSIS and Microsoft Fabric",
        "Structuring of internal surveys in MongoDB",
        "NLP analysis of employee comments via Python",
        "Creation of HR KPIs in DAX",
        "Development of Power BI dashboards",
        "Implementation of a simple HR churn prediction model"
      ],
      m15: [
        "Requirements gathering and business needs assessment",
        "Design of data models and cost simulation dashboards",
        "Project budget monitoring",
        "User training and support",
        "Incident management and documentation"
      ],
      m16: [
        "Analysis and structuring of business needs",
        "Optimization of existing data model",
        "Definition of Qlik Sense development best practices",
        "Technical and functional scoping of the new version"
      ],
      m17: [
        "Evolutive and corrective maintenance of Qlik Sense applications",
        "Multi-zone application support",
        "Deployment of new features",
        "Development of business applications",
        "Non-regression testing"
      ],
      m18: [
        "Installation and configuration of Qlik Sense server",
        "Requirements gathering from different entities",
        "Development of data transformations",
        "Production of business-oriented reports and analyses",
        "Application of Agile practices"
      ],
      m19: [
        "Supply Chain data mapping",
        "Development of QlikView reports",
        "Analysis of transport flows and associated costs",
        "Supplier performance monitoring",
        "Coordination with Supply Chain and IT departments"
      ],
      m20: [
        "Data collection, cleaning and reliability",
        "Exploratory analysis and data mining",
        "Data visualization for audit support",
        "Technical and business documentation of analyses"
      ]
    },
    missions: {
      label: "Selected Work",
      title: "Mission Portfolio",
      description: "A selection of consulting missions across various industries and technologies.",
      filterLabel: "Filter Missions",
      clearAll: "Clear All",
      allTechnologies: "All Technologies",
      allSectors: "All Sectors",
      allCountries: "All Countries",
      allEmployers: "All Employers",
      allSkills: "All Skills",
      filteredBySkill: "Filtered by skill",
      internalMission: "internal mission",
      showing: "Showing",
      of: "of",
      missionsLabel: "missions",
      noResults: "No missions match your current filters.",
      clearFilters: "Clear Filters",
      businessContext: "Business Context",
      responsibilities: "Main Responsibilities",
      technologies: "Technologies Used"
    },
    employers: {
      label: "Career Path",
      title: "Employers",
      description: "Key employers and consulting firms I have collaborated with throughout my career.",
      skillsApplied: "Skills Applied",
      missionsDelivered: "Missions Delivered",
      clientsServed: "Clients Served"
    },
    contact: {
      label: "Get in Touch",
      title: "Contact",
      description: "I am open to discussing new opportunities in Data & Business Intelligence consulting.",
      aboutMe: "About Me",
      aboutText: "With over 9 years of experience in decision-support systems, data modeling, and BI delivery, I have built my career around multi-client, international, and demanding contexts.\n\nI work on both business scoping and technical design, with a pragmatic approach focused on usability, performance, and data reliability.\n\nWhether it's reinforcing a team on a complex BI project, structuring a decision-support platform, or helping users adopt new tools, I bring operational expertise and a senior consultant perspective.\n\nFor a one-time need or longer-term collaboration, I am open to discussion.",
      openToOpportunities: "Open to Opportunities",
      contactInfo: "Contact Information",
      email: "Email",
      phone: "Phone",
      linkedin: "LinkedIn",
      viewProfile: "View Profile",
      location: "Location",
      locationMobility: "Location & Mobility",
      mobility: "Mobility",
      sendEmail: "Send Email"
    },
    // Certifications page
    certifications: {
      title: "Certifications",
      description: "Professional certifications obtained and in progress.",
      obtained: "Certifications obtained",
      inProgress: "Certifications in progress",
      certified: "Certified",
      inProgressStatus: "In progress",
      issuer: "Issuer",
      obtainedDate: "Date obtained",
      expirationDate: "Expiration date"
    },
    // Certifications data
    certificationsData: {
      obtained: [
        {
          name: "Qlik Sense Data Architect Certification",
          issuer: "Qlik",
          obtainedDate: "February 7, 2025",
          expirationDate: "February 7, 2027",
          badgeImage: "/images/qlik-data-architect-badge.png"
        }
      ],
      inProgress: [
        {
          name: "Microsoft Power BI PL-300",
          issuer: "Microsoft"
        }
      ]
    },
    contactData: {
      email: "dossa.jojo@gmail.com",
      phone: "+33 7 84 94 73 20",
      location: "France",
      mobility: "France"
    },
    footer: {
      navigation: "Navigation",
      contact: "Contact",
      rights: "All rights reserved",
      consultant: "Data & BI Consultant"
    },
    common: {
      endClient: "End Client",
      consultingFirm: "Consulting Firm"
    },
    // AI Projects page
    aiProjects: {
      label: "Personal Projects",
      title: "Personal Projects – AI & Automation",
      description: "This section presents personal projects in which AI and no-code tools were used to accelerate design, structure requirements, or implement concrete solutions. The focus is not on the tool itself, but on the problem solved and how the solution was built.",
      context: "Context",
      approach: "Approach",
      aiRole: "Role of AI / no-code",
      result: "Result"
    },
    // AI Projects data
    aiProjectsData: [
      {
        id: "pastry-orders",
        title: "Order Management Tool for Pastry Business",
        context: "Artisanal business with orders coming from multiple channels (WhatsApp, calls, messages), leading to oversights, tracking errors, and significant mental load.",
        approach: "Analysis of the different stages of order management (order taking, preparation, delivery), then structuring a simple system to centralize requests and track orders.",
        aiRole: "Use of no-code tools and AI to quickly design a solution adapted to real-world usage, test multiple approaches, and progressively adjust the functionality.",
        result: "Better visibility on orders, reduction of oversights, and smoother daily management."
      },
      {
        id: "malivraison-plus",
        title: "MaLivraison+",
        context: "Design of a delivery application involving several types of users (customers, delivery drivers, partners), with different business flows to structure.",
        approach: "Work on organizing main flows, interaction logic between actors, data circulation, and overall system coherence.",
        aiRole: "Use of AI and tools like Emergent.sh to prototype, accelerate design, formalize certain usage logic, and quickly test different functional structures.",
        result: "Transition from fragmented logic to a more coherent and usable structure."
      },
      {
        id: "ai-experiments",
        title: "AI / No-code Experiments",
        context: "Exploration of solutions to save time on requirement structuring, prototyping, and automation of simple tasks.",
        approach: "Testing different approaches on concrete cases related to data, user flows, and functional documentation.",
        aiRole: "Use of tools such as ChatGPT, Claude, Emergent.sh, Bubble, and other no-code solutions to quickly experiment, compare options, and produce first usable versions.",
        result: "Development of a faster and more pragmatic approach to move from a requirement to a testable solution."
      }
    ],
    sectors: ["Transport / Maritime / Logistics", "Consulting / Business Intelligence", "Banking / Public Finance", "Retail / Large-scale distribution", "Insurance / Financial Services", "Consulting / BI Training", "Investment Banking", "Banking", "Education / HR", "Industry / Transport", "Industry", "Luxury", "Retail / E-commerce", "Industry / Supply Chain", "Tourism / Audit"],
    countries: ["France", "Benin", "International (Europe, Asia, China)"]
  },

  de: {
    nav: {
      home: "Startseite",
      skills: "Kompetenzen",
      missions: "Projekte",
      employers: "Arbeitgeber",
      certifications: "Zertifizierungen",
      projects: "KI-Projekte",
      contact: "Kontakt",
      downloadCV: "Lebenslauf"
    },
    profile: {
      name: "Joel Dossa",
      title: "Senior Data & Business Intelligence Berater",
      summary: "Als Senior Data & Business Intelligence Berater unterstütze ich Organisationen bei der Konzeption und Umsetzung robuster Entscheidungslösungen, von der Datenmodellierung bis zur Bereitstellung hochwertiger Business Intelligence Tools. Erfahren in komplexen Multi-Client-Umgebungen, arbeite ich an anspruchsvollen BI-Projekten in Frankreich und international.",
      location: "Frankreich",
      availability: "Offen für Möglichkeiten"
    },
    highlights: [
      "9+ Jahre Erfahrung in Data & BI",
      "Experte für Entscheidungssysteme",
      "Spezialist für Datenmodellierung",
      "Multi-Client & internationale Erfahrung"
    ],
    home: {
      label: "Senior Berater",
      title1: "Data &",
      title2: "Business",
      title3: "Intelligence",
      yearsExp: "Jahre Erfahrung",
      projectsDelivered: "Projekte geliefert",
      sectorsCovered: "Branchen abgedeckt",
      countries: "Länder",
      skillsCard: {
        title: "Kompetenzen & Expertise",
        description: "Technische Fähigkeiten, BI-Tools und Kompetenzen",
        cta: "Entdecken"
      },
      missionsCard: {
        title: "Projektportfolio",
        description: "Beratungsprojekte in verschiedenen Branchen",
        cta: "Projekte ansehen"
      },
      employersCard: {
        title: "Karriereweg",
        description: "Arbeitgeber und Beratungsfirmen",
        cta: "Arbeitgeber ansehen"
      }
    },
    skills: {
      label: "Was ich mache",
      title: "Kompetenzen & Expertise",
      description: "Klicken Sie auf eine Kompetenz, um zugehörige Projekte, Kunden und Arbeitgeber zu erkunden.",
      missions: "Projekte",
      relatedMissions: "Zugehörige Projekte",
      employers: "Arbeitgeber",
      categories: {
        core: "Kernkompetenzen",
        tools: "BI-Tools",
        technical: "Technische Fähigkeiten",
        business: "Geschäftliche Fähigkeiten",
        management: "Management"
      }
    },
    skillsData: [
      { id: "bi", name: "Business Intelligence", category: "Core", description: "End-to-End BI-Lösungsdesign, Implementierung und Governance", missionCount: 6 },
      { id: "qlik", name: "Qlik Sense / QlikView", category: "Tools", description: "Dashboard-Entwicklung, Datenmodellierung, Set-Analyse, NPrinting", missionCount: 4 },
      { id: "powerbi", name: "Power BI", category: "Tools", description: "Berichtsentwicklung, DAX, Power Query, Dataflows", missionCount: 2 },
      { id: "datamodel", name: "Datenmodellierung & Data Warehouse", category: "Core", description: "Sternschema, dimensionale Modellierung, Data Vault", missionCount: 5 },
      { id: "sql", name: "SQL & Datenbanken", category: "Technical", description: "SQL Server, Oracle, PostgreSQL, Abfrageoptimierung", missionCount: 5 },
      { id: "etl", name: "ETL & Datenintegration", category: "Technical", description: "Talend, SSIS, Datenpipelines, API-Integration", missionCount: 3 },
      { id: "kpi", name: "KPI & Entscheidungsunterstützung", category: "Business", description: "KPI-Definition, Steuerungs-Dashboards, Executive Reporting", missionCount: 5 },
      { id: "dataquality", name: "Datenqualität & Governance", category: "Business", description: "Datenqualitäts-Frameworks, Stammdatenmanagement, Dokumentation", missionCount: 3 },
      { id: "project", name: "Projekt- & Stakeholder-Management", category: "Management", description: "Agile/Scrum, Stakeholder-Koordination, Anforderungserhebung", missionCount: 6 },
      { id: "training", name: "Schulung & Benutzerunterstützung", category: "Management", description: "Erstellung von Schulungsmaterialien, BI-Schulungen, Benutzerunterstützung und Kompetenzentwicklung der Teams", missionCount: 3 }
    ],
    employersData: [
      { id: "keyrus", name: "Keyrus", type: "Beratungsfirma", duration: "Januar 2025 - Heute", location: "Paris, Frankreich", description: "Internationale Datenberatungsgruppe" },
      { id: "itcoop", name: "IT-COOP", type: "Beratungsfirma", duration: "Januar 2023 - Dezember 2024", location: "Paris, Frankreich", description: "Beratungsunternehmen spezialisiert auf Data & Business Intelligence" },
      { id: "vo2", name: "VO2 GROUP", type: "Beratungsfirma", duration: "September 2017 - Dezember 2022", location: "Paris, Frankreich", description: "Data & Digital Beratungsunternehmen" },
      { id: "gmf", name: "GMF Groupe Covéa", type: "Endkunde", duration: "Dezember 2016 - August 2017", location: "Paris, Frankreich", description: "Großer französischer Versicherungskonzern innerhalb von Covéa" }
    ],
    missionsData: [
      { id: "m6", title: "Qlik Sense Trainer & Support-Verantwortlicher", employer: "keyrus", client: "CMA CGM", sector: "Transport / Maritime / Logistik", country: "Frankreich", context: "Entwicklung einer Qlik Sense Anwendung zur Verfolgung maritimer Partnerschaftsvereinbarungen im Rahmen der Optimierungsstrategie der Pool & Partnership Abteilung. Ziel ist es, den Geschäftsteams ein Reporting- und Analysetool zur Verwaltung von Schiffsraumzuweisungen und zur Bewertung der Partnerschaftsleistung bereitzustellen.", techs: "Qlik Sense, JSON, Excel, SharePoint, VS Code, GitLab" },
      { id: "m7", title: "BI-Referent", employer: "itcoop", client: "IT-COOP (interne Mission)", sector: "Beratung / Business Intelligence", country: "Frankreich", context: "Einrichtung und Verwaltung der internen Qlik Sense Plattform. Einarbeitung neuer Mitarbeiter, Schulung, Support und Technologieüberwachung zur kontinuierlichen Optimierung und Anpassung der BI-Lösungen an die Geschäftsanforderungen. Hauptansprechpartner für alle technischen oder funktionalen Fragen zu Qlik Sense im Unternehmen.", techs: "Qlik Sense, Power BI" },
      { id: "m8", title: "Qlik Sense Entwickler", employer: "itcoop", client: "Bpifrance", sector: "Bankwesen / Öffentliche Finanzen", country: "Frankreich", context: "Konzeption, evolutive und korrektive Wartung von Qlik Sense Anwendungen. Optimierung der Datenmodelle zur Reduzierung der Ladezeiten und Verbesserung der Anwendungsleistung. Betroffene Anwendungen: GED (Elektronische Dokumentenverwaltung), MaReco (Digitales Marketing-Tool), Matomo (Webanalyse), ACE (Unternehmensbegleitung), UNIV (Schulungsdatenverfolgung).", techs: "Qlik Sense, GitLab, Jenkins, AWS, Jira, Neurone, Datalink (DataGalaxy)" },
      { id: "m9", title: "Optimierung von Vertrieb und Einzelhandelsleistung über Power BI und SQL Server", employer: "itcoop", client: "Super U Benin", sector: "Einzelhandel / Großvertrieb", country: "Benin", context: "Vertriebs- und Steuerungsprojekt zur Reduzierung von Lagerbeständen, Verbesserung des Produktumsatzes und Bereitstellung von Schlüsselindikatoren für Einzelhandelsgeschäftsteams. Strukturierung von Datenflüssen zwischen Quellsystemen (ERP, E-Commerce, Kundenbestellungen) und Modellierung eines leistungsstarken Data Warehouse zur Versorgung von Power BI Dashboards.", techs: "SQL Server, SSIS, Power BI, DAX, Power Query, MongoDB, Python, Azure ML, Data Quality Services (DQS), Excel" },
      { id: "m10", title: "BI-Entwickler", employer: "gmf", client: "GMF Groupe Covéa", sector: "Versicherung / Finanzdienstleistungen", country: "Frankreich", context: "Analyse- und Überwachungsmission der GMF VIE Contact-Center-Aktivität, mit dem Ziel, eine konsolidierte und zuverlässige Sicht auf die operative Leistung und Telefonieflüsse zur Unterstützung der Entscheidungsfindung bereitzustellen.", techs: "Oracle SQL Developer, IBM DB2, SAS Add-In, Excel, Business Objects, Power BI" },
      { id: "m11", title: "Qlik Sense Trainer & Support-Verantwortlicher", employer: "vo2", client: "VO2 GROUP / Orsys", sector: "Beratung / BI-Schulung", country: "Frankreich", context: "Schulungs- und Supportmission rund um Qlik Sense, intern bei VO2 GROUP und bei Kundenunternehmen im Rahmen von Partnerschaften mit Orsys durchgeführt.", techs: "QlikView, Qlik Sense" },
      { id: "m12", title: "Qlik Sense Entwickler", employer: "vo2", client: "BNP Paribas CIB", sector: "Investmentbanking", country: "Frankreich", context: "Entwicklung von Budget-Dashboards im Zusammenhang mit dem IT-Materialverbrauch.", techs: "Qlik Sense, NPrinting, Oracle, Excel" },
      { id: "m13", title: "Steuerung der Finanzleistung und regulatorischen Risiken", employer: "vo2", client: "Banque Atlantique", sector: "Bankwesen", country: "Benin", context: "Implementierung eines zentralisierten Tools zur Überwachung der Finanzleistung, Risikoindikatoren und regulatorischen Compliance, ausgerichtet an BCEAO-Standards.", techs: "SQL Server, Microsoft Fabric, SSIS, Python, Power BI, DAX, Excel, Git" },
      { id: "m14", title: "HR-Analyse und Mitarbeiterengagement", employer: "vo2", client: "Institut Universitaire La Grâce", sector: "Bildung / HR", country: "Benin", context: "Implementierung eines HR-Analysetools zur Überwachung der HR-Leistung, Abwesenheitsrate und des Mitarbeiterengagements.", techs: "SQL Server, Microsoft Fabric, SSIS, MongoDB, Python (NLP), Power BI, DAX, Excel" },
      { id: "m15", title: "Projektleiter / Qlik Sense Entwickler", employer: "vo2", client: "Alstom", sector: "Industrie / Transport", country: "Frankreich", context: "Evolutive Wartung von Qlik Sense Anwendungen zur Bewertung und Optimierung der Zugproduktionskosten.", techs: "Oracle, Qlik Sense" },
      { id: "m16", title: "Qlik Sense Expertise", employer: "vo2", client: "Saint-Gobain", sector: "Industrie", country: "Frankreich", context: "Strategische Optimierung des Datenmodells und Unterstützung bei der Konzeption von Version 2 der DecQlik-Anwendung für die Verkaufsverfolgung.", techs: "Qlik Sense, SQL Server, Jira" },
      { id: "m17", title: "Qlik Sense Entwickler", employer: "vo2", client: "LVMH-PCIS", sector: "Luxus", country: "International (Europa, Asien, China)", context: "CLIENTQUEST-Projekt für Support und Entwicklung von Qlik Sense Anwendungen auf mehreren internationalen Plattformen.", techs: "Qlik Sense, Azure, SQL Server, Jira" },
      { id: "m18", title: "Qlik Sense Expertise", employer: "vo2", client: "Carrefour", sector: "Einzelhandel / E-Commerce", country: "Frankreich", context: "Digitales Transformationsprojekt für die E-Commerce-Aktivität.", techs: "Qlik Sense, PostgreSQL" },
      { id: "m19", title: "QlikView Entwickler", employer: "vo2", client: "Lafarge", sector: "Industrie / Supply Chain", country: "Frankreich", context: "EBM-Projekt zur Optimierung der Supply-Chain-Leistung und operativen Entscheidungsfindung.", techs: "QlikView" },
      { id: "m20", title: "Data Analyst – Interne Revision", employer: "vo2", client: "Nonvi Voyage", sector: "Tourismus / Audit", country: "Benin", context: "Unterstützung der internen Revisionsteams bei der Datensammlung, -nutzung und -analyse.", techs: "Python, Excel, Power BI" }
    ],
    missionDetails: {
      m6: [
        "Erhebung und Formalisierung funktionaler Anforderungen bei Geschäftsteams (Partnerschaft-Controller, Pool & Partnership Analysten, internes BI-Team)",
        "Datenmodellierung aus verschiedenen internen Quellen",
        "Entwicklung dynamischer und interaktiver Qlik Sense Dashboards",
        "Implementierung von Geschäfts-KPIs zur Verfolgung der Vereinbarungsleistung",
        "Erstellung technischer und funktionaler Dokumentation für die Anwendung",
        "Benutzerunterstützung während der Einarbeitungsphase"
      ],
      m7: [
        "Einrichtung und Verwaltung der Qlik Sense Plattform",
        "Einarbeitung neuer Mitarbeiter in Qlik Sense",
        "Schulung und Betreuung der Teammitglieder",
        "Erstellung von Schulungsmaterialien und Durchführung interner Sitzungen",
        "Funktionaler und technischer Support für Benutzer",
        "Technologieüberwachung im Qlik und Power BI Ökosystem"
      ],
      m8: [
        "Erhebung von Geschäftsanforderungen und Aufgabenplanung",
        "Erstellung und Verwaltung von QVDs (QVD Maker)",
        "Konzeption und evolutive Wartung von Qlik Sense Anwendungen",
        "Optimierung der Ladezeiten",
        "Funktionale Reviews mit Geschäftsteams",
        "Produktionsbereitstellung und Überwachung",
        "Funktionale und technische Dokumentation (Neurone, Datalink / DataGalaxy)"
      ],
      m9: [
        "Konzeption und Automatisierung von Datenflüssen über SSIS",
        "Integration von E-Commerce-Daten aus MongoDB über Python-Skripte",
        "Data Warehouse Modellierung (langsam ändernde Dimensionen, Bestands- und Preishistorisierung)",
        "Erstellung von Power BI Dashboards (Verkäufe, Lagerbestände, Umsatz)",
        "Definition von Geschäfts-KPIs und Benutzerunterstützung",
        "Implementierung von Datenqualitäts- und Governance-Regeln (DQS, Power Query)"
      ],
      m10: [
        "Sammlung und detaillierte Analyse der GMF VIE Contact-Center-Aktivitätsdaten zur Verbesserung des Verständnisses der Telefonie-Managementprozesse",
        "Entwicklung grafischer Dashboards aus den Daten der Contact-Center-Verwaltungstools mit einer umfassenden und synthetischen Übersicht der Aktivität",
        "Durchführung von Tests unter Business Objects zur Validierung der Zuverlässigkeit der Telefoniestatistiken",
        "Extraktion spezifischer Statistiken mittels SQL-Abfragen zur Erfüllung von Ad-hoc-Analyseanforderungen",
        "Erstellung von Prognosen zur Entwicklung der Contact-Center-Aktivität zur Unterstützung strategischer und operativer Entscheidungen"
      ],
      m11: [
        "Erstellung von Schulungsmaterialien (Leitfäden, Tutorials) zur Erleichterung des Qlik Sense Lernens",
        "Durchführung von Schulungssitzungen für interne Teams",
        "Trainereinsätze bei Orsys-Kundenunternehmen",
        "Anpassung von Inhalten und Lehrmethoden an die Benutzerbedürfnisse",
        "Nachbetreuung und Unterstützung nach der Schulung",
        "Pädagogische und technische Überwachung der Qlik Sense Entwicklungen"
      ],
      m12: [
        "Wartung und Weiterentwicklung von Qlik Sense Anwendungen",
        "Aktualisierung und Zuverlässigkeit der Datenquellen",
        "Neugestaltung von Anwendungen zur Verbesserung der Benutzererfahrung",
        "Optimierung von Ladezeiten und Leistung"
      ],
      m13: [
        "Integration von Finanztransaktionen in SQL Server über Python-Skripte",
        "Zentralisierung von Buchhaltungs- und Regulierungsdaten über Microsoft Fabric",
        "Automatisierte Aufnahme von Buchhaltungshistorien über SSIS",
        "Berechnung von Risikoindikatoren (VaR, Sharpe Ratio, Drawdown)",
        "Erstellung komplexer Finanzkennzahlen in DAX",
        "Entwicklung von Power BI Dashboards für Management und Analysten",
        "Implementierung von Compliance-Regeln und regulatorischen Warnungen"
      ],
      m14: [
        "Integration von HR-Daten über SSIS und Microsoft Fabric",
        "Strukturierung interner Umfragen in MongoDB",
        "NLP-Analyse von Mitarbeiterkommentaren über Python",
        "Erstellung von HR-KPIs in DAX",
        "Entwicklung von Power BI Dashboards",
        "Implementierung eines einfachen HR-Churn-Vorhersagemodells"
      ],
      m15: [
        "Anforderungserhebung und Bewertung der Geschäftsanforderungen",
        "Design von Datenmodellen und Kostensimulations-Dashboards",
        "Projektbudgetüberwachung",
        "Benutzerschulung und -unterstützung",
        "Incident-Management und Dokumentation"
      ],
      m16: [
        "Analyse und Strukturierung von Geschäftsanforderungen",
        "Optimierung des bestehenden Datenmodells",
        "Definition von Qlik Sense Entwicklungs-Best-Practices",
        "Technisches und funktionales Scoping der neuen Version"
      ],
      m17: [
        "Evolutive und korrektive Wartung von Qlik Sense Anwendungen",
        "Multi-Zonen-Anwendungssupport",
        "Bereitstellung neuer Funktionen",
        "Entwicklung von Geschäftsanwendungen",
        "Nicht-Regressionstests"
      ],
      m18: [
        "Installation und Konfiguration des Qlik Sense Servers",
        "Anforderungserhebung bei verschiedenen Abteilungen",
        "Entwicklung von Datentransformationen",
        "Erstellung geschäftsorientierter Berichte und Analysen",
        "Anwendung agiler Praktiken"
      ],
      m19: [
        "Mapping von Supply-Chain-Daten",
        "Entwicklung von QlikView-Berichten",
        "Analyse von Transportflüssen und zugehörigen Kosten",
        "Überwachung der Lieferantenleistung",
        "Koordination mit Supply Chain und IT-Abteilungen"
      ],
      m20: [
        "Datensammlung, -bereinigung und -zuverlässigkeit",
        "Explorative Analyse und Data Mining",
        "Datenvisualisierung für Audit-Unterstützung",
        "Technische und geschäftliche Dokumentation der Analysen"
      ]
    },
    missions: {
      label: "Ausgewählte Arbeiten",
      title: "Projektportfolio",
      description: "Eine Auswahl von Beratungsprojekten in verschiedenen Branchen und Technologien.",
      filterLabel: "Projekte filtern",
      clearAll: "Alle löschen",
      allTechnologies: "Alle Technologien",
      allSectors: "Alle Branchen",
      allCountries: "Alle Länder",
      allEmployers: "Alle Arbeitgeber",
      allSkills: "Alle Kompetenzen",
      filteredBySkill: "Gefiltert nach Kompetenz",
      internalMission: "interne Mission",
      showing: "Anzeige von",
      of: "von",
      missionsLabel: "Projekten",
      noResults: "Keine Projekte entsprechen Ihren Filtern.",
      clearFilters: "Filter löschen",
      businessContext: "Geschäftskontext",
      responsibilities: "Hauptverantwortlichkeiten",
      technologies: "Verwendete Technologien"
    },
    employers: {
      label: "Karriereweg",
      title: "Arbeitgeber",
      description: "Die wichtigsten Arbeitgeber und Beratungsfirmen, mit denen ich zusammengearbeitet habe.",
      skillsApplied: "Angewandte Kompetenzen",
      missionsDelivered: "Durchgeführte Projekte",
      clientsServed: "Betreute Kunden"
    },
    contact: {
      label: "Kontakt aufnehmen",
      title: "Kontakt",
      description: "Ich bin offen für Gespräche über neue Möglichkeiten in der Data & Business Intelligence Beratung.",
      aboutMe: "Über mich",
      aboutText: "Mit über 9 Jahren Erfahrung in Entscheidungsunterstützungssystemen, Datenmodellierung und BI-Bereitstellung habe ich meinen Werdegang in Multi-Client-, internationalen und anspruchsvollen Kontexten aufgebaut.\n\nIch arbeite sowohl an der fachlichen Rahmung als auch an der technischen Konzeption, mit einem pragmatischen Ansatz, der auf Nutzbarkeit, Leistung und Datenzuverlässigkeit ausgerichtet ist.\n\nOb es darum geht, ein Team bei einem komplexen BI-Projekt zu verstärken, eine Entscheidungsplattform zu strukturieren oder Benutzer bei der Einführung von Tools zu begleiten – ich bringe operative Expertise und die Perspektive eines Senior-Beraters mit.\n\nFür einen punktuellen Bedarf oder eine längerfristige Zusammenarbeit bin ich offen für den Austausch.",
      openToOpportunities: "Offen für Möglichkeiten",
      contactInfo: "Kontaktinformationen",
      email: "E-Mail",
      phone: "Telefon",
      linkedin: "LinkedIn",
      viewProfile: "Profil ansehen",
      location: "Standort",
      locationMobility: "Standort & Mobilität",
      mobility: "Mobilität",
      sendEmail: "E-Mail senden"
    },
    // Certifications page
    certifications: {
      title: "Zertifizierungen",
      description: "Erworbene und laufende berufliche Zertifizierungen.",
      obtained: "Erworbene Zertifizierungen",
      inProgress: "Laufende Zertifizierungen",
      certified: "Zertifiziert",
      inProgressStatus: "In Bearbeitung",
      issuer: "Aussteller",
      obtainedDate: "Erhaltungsdatum",
      expirationDate: "Ablaufdatum"
    },
    // Certifications data
    certificationsData: {
      obtained: [
        {
          name: "Qlik Sense Data Architect Certification",
          issuer: "Qlik",
          obtainedDate: "7. Februar 2025",
          expirationDate: "7. Februar 2027",
          badgeImage: "/images/qlik-data-architect-badge.png"
        }
      ],
      inProgress: [
        {
          name: "Microsoft Power BI PL-300",
          issuer: "Microsoft"
        }
      ]
    },
    contactData: {
      email: "dossa.jojo@gmail.com",
      phone: "+33 7 84 94 73 20",
      location: "Frankreich",
      mobility: "Frankreich"
    },
    footer: {
      navigation: "Navigation",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten",
      consultant: "Data & BI Berater"
    },
    common: {
      endClient: "Endkunde",
      consultingFirm: "Beratungsfirma"
    },
    // AI Projects page
    aiProjects: {
      label: "Persönliche Projekte",
      title: "Persönliche Projekte – KI & Automatisierung",
      description: "Dieser Abschnitt präsentiert persönliche Projekte, in denen KI und No-Code-Tools eingesetzt wurden, um das Design zu beschleunigen, Anforderungen zu strukturieren oder konkrete Lösungen umzusetzen. Der Fokus liegt nicht auf dem Tool selbst, sondern auf dem gelösten Problem und der Art, wie die Lösung entwickelt wurde.",
      context: "Kontext",
      approach: "Ansatz",
      aiRole: "Rolle der KI / No-Code",
      result: "Ergebnis"
    },
    // AI Projects data
    aiProjectsData: [
      {
        id: "pastry-orders",
        title: "Bestellmanagement-Tool für Konditorei",
        context: "Handwerksbetrieb mit Bestellungen über mehrere Kanäle (WhatsApp, Anrufe, Nachrichten), was zu Versäumnissen, Verfolgungsfehlern und erheblicher mentaler Belastung führte.",
        approach: "Analyse der verschiedenen Phasen des Bestellmanagements (Bestellannahme, Vorbereitung, Lieferung), dann Strukturierung eines einfachen Systems zur Zentralisierung der Anfragen und Verfolgung der Bestellungen.",
        aiRole: "Einsatz von No-Code-Tools und KI, um schnell eine an die reale Nutzung angepasste Lösung zu entwickeln, mehrere Ansätze zu testen und die Funktionalität schrittweise anzupassen.",
        result: "Bessere Übersicht über Bestellungen, weniger Versäumnisse und flüssigeres Tagesmanagement."
      },
      {
        id: "malivraison-plus",
        title: "MaLivraison+",
        context: "Entwicklung einer Liefer-App mit mehreren Benutzertypen (Kunden, Lieferfahrer, Partner) und verschiedenen zu strukturierenden Geschäftsabläufen.",
        approach: "Arbeit an der Organisation der Hauptabläufe, der Interaktionslogik zwischen Akteuren, dem Datenfluss und der Gesamtkohärenz des Systems.",
        aiRole: "Einsatz von KI und Tools wie Emergent.sh zum Prototyping, zur Beschleunigung des Designs, zur Formalisierung bestimmter Nutzungslogiken und zum schnellen Testen verschiedener funktionaler Strukturen.",
        result: "Übergang von einer fragmentierten Logik zu einer kohärenteren und nutzbaren Struktur."
      },
      {
        id: "ai-experiments",
        title: "KI / No-Code Experimente",
        context: "Erkundung von Lösungen zur Zeitersparnis bei der Anforderungsstrukturierung, dem Prototyping und der Automatisierung einfacher Aufgaben.",
        approach: "Testen verschiedener Ansätze an konkreten Fällen im Zusammenhang mit Daten, Benutzerflüssen und funktionaler Dokumentation.",
        aiRole: "Einsatz von Tools wie ChatGPT, Claude, Emergent.sh, Bubble und anderen No-Code-Lösungen zum schnellen Experimentieren, Vergleichen von Optionen und Erstellen erster nutzbarer Versionen.",
        result: "Entwicklung eines schnelleren und pragmatischeren Ansatzes, um von einer Anforderung zu einer testbaren Lösung zu gelangen."
      }
    ],
    sectors: ["Transport / Maritime / Logistik", "Beratung / Business Intelligence", "Bankwesen / Öffentliche Finanzen", "Einzelhandel / Großvertrieb", "Versicherung / Finanzdienstleistungen", "Beratung / BI-Schulung", "Investmentbanking", "Bankwesen", "Bildung / HR", "Industrie / Transport", "Industrie", "Luxus", "Einzelhandel / E-Commerce", "Industrie / Supply Chain", "Tourismus / Audit"],
    countries: ["Frankreich", "Benin", "International (Europa, Asien, China)"]
  }
};

export const defaultLanguage = 'fr';
export const supportedLanguages = ['fr', 'en', 'de'];
export const languageNames = {
  fr: 'FR',
  en: 'EN',
  de: 'DE'
};

// Categories for skills (same IDs across languages)
export const categories = [
  { id: "Core" },
  { id: "Tools" },
  { id: "Technical" },
  { id: "Business" },
  { id: "Management" }
];

// Mapping data (language-independent)
export const skillMissionMap = {
  bi: ["m6", "m7", "m8", "m9", "m10", "m11", "m12", "m13", "m14", "m15", "m16", "m17", "m18", "m19", "m20"],
  qlik: ["m6", "m7", "m8", "m11", "m12", "m15", "m16", "m17", "m18", "m19"],
  powerbi: ["m7", "m9", "m10", "m13", "m14", "m20"],
  datamodel: ["m6", "m8", "m9", "m13", "m14", "m15", "m16"],
  sql: ["m9", "m10", "m12", "m13", "m14", "m16", "m17"],
  etl: ["m9", "m13", "m14"],
  kpi: ["m6", "m9", "m10", "m13", "m14"],
  dataquality: ["m9", "m13"],
  project: ["m6", "m7", "m8", "m11", "m15", "m17", "m18"],
  training: ["m6", "m7", "m11"]
};

export const skillEmployerMap = {
  bi: ["keyrus", "itcoop", "gmf", "vo2"],
  qlik: ["keyrus", "itcoop", "vo2"],
  powerbi: ["itcoop", "gmf", "vo2"],
  datamodel: ["keyrus", "itcoop", "vo2"],
  sql: ["itcoop", "gmf", "vo2"],
  etl: ["itcoop", "vo2"],
  kpi: ["keyrus", "itcoop", "gmf", "vo2"],
  dataquality: ["itcoop", "vo2"],
  project: ["keyrus", "itcoop", "vo2"],
  training: ["keyrus", "itcoop", "vo2"]
};

export const employerMissionsMap = {
  keyrus: ["m6"],
  itcoop: ["m7", "m8", "m9"],
  vo2: ["m11", "m12", "m13", "m14", "m15", "m16", "m17", "m18", "m19", "m20"],
  gmf: ["m10"]
};

export const employerSkillsMap = {
  keyrus: ["bi", "qlik", "kpi", "project", "datamodel", "training"],
  itcoop: ["bi", "qlik", "powerbi", "datamodel", "sql", "etl", "kpi", "dataquality", "project", "training"],
  vo2: ["bi", "qlik", "powerbi", "datamodel", "sql", "etl", "kpi", "dataquality", "project", "training"],
  gmf: ["bi", "sql", "kpi", "powerbi"]
};

// Technologies (same across languages)
export const technologies = ["Qlik Sense", "QlikView", "Power BI", "SQL Server", "SSIS", "DAX", "Power Query", "MongoDB", "Python", "Azure ML", "Azure", "AWS", "GitLab", "Jenkins", "Jira", "JSON", "Excel", "SharePoint", "Data Quality Services (DQS)", "Neurone", "Datalink (DataGalaxy)", "Oracle SQL Developer", "Oracle", "IBM DB2", "SAS Add-In", "Business Objects", "NPrinting", "Microsoft Fabric", "Git", "PostgreSQL"];
